<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 23 23"
  >
    <g fill="none" fill-rule="evenodd">
      <circle cx="11.5" cy="11.5" r="11" fill="#FFF" stroke="#D6D3D0" />
      <circle cx="11.5" cy="6.5" r="1.5" :fill="color" />
      <circle cx="11.5" cy="11.5" r="1.5" :fill="color" />
      <circle cx="11.5" cy="16.5" r="1.5" :fill="color" />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#5C5957",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
